import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const userRaw = localStorage.getItem("user");
  if (!userRaw) return <Navigate to="/" replace />;

  const user = JSON.parse(userRaw);
  return user?.role === "admin" ? children : <Navigate to="/events" replace />;
};

export default AdminRoute;
